import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { PeppolAPTestbedSendingDocHdrContainerModel } from '../../../../../../models/aggregates/e-invoice/peppol/bl_ppl_ap_testbed_sending_doc_hdr.model';

@Injectable({
  providedIn: 'root'
})
export class PeppolAPTestbedSendingDocHdrService extends BaseApiTemplateService<PeppolAPTestbedSendingDocHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'ppl/ap/testbed-sending-doc-hdrs/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'ppl/ap/testbed-sending-doc-hdrs/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'ppl/ap/testbed-sending-doc-hdrs/backoffice-ep'
    this.httpClient = http;
  }
}
